import React, { createContext, useContext, useEffect, useState } from 'react';
import { Policies, PoliciesStatus } from './Policies';

interface PolicyContextProps {
    policies: PoliciesStatus;
    loading: boolean;
    error: string | null;
}

const PolicyContext = createContext<PolicyContextProps>({
    policies: {} as PoliciesStatus, // Placeholder, will be populated
    loading: true,
    error: null
});

export const PolicyProvider: React.FC = ({ children }) => {
    // Initialize all policies to false
    const initialPolicies: PoliciesStatus = Object.values(Policies).reduce((acc, policy) => {
        acc[policy] = false;
        return acc;
    }, {} as PoliciesStatus);

    const [policies, setPolicies] = useState<PoliciesStatus>(initialPolicies);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchPolicies = async () => {
            try {
                const response = await fetch('/api/user/policies', {
                    credentials: 'include', // Include cookies if needed
                });
                if (response.ok) {
                    const data: { [key: string]: boolean } = await response.json();

                    // Create a new PoliciesStatus object based on initialPolicies
                    const updatedPolicies: PoliciesStatus = { ...initialPolicies };

                    // Iterate over the response data and set policies to true where applicable
                    for (const policyName in data) {
                        if (Object.values(Policies).includes(policyName as Policies)) {
                            updatedPolicies[policyName as Policies] = data[policyName];
                        }
                    }

                    setPolicies(updatedPolicies);
                } else {
                    setError('Failed to fetch policies.');
                    console.error('Failed to fetch policies:', response.statusText);
                }
            } catch (err) {
                setError('An error occurred while fetching policies.');
                console.error('Error fetching policies:', err);
            } finally {
                setLoading(false);

                console.log(policies);
            }
        };

        fetchPolicies();
    }, []);

    return (
        <PolicyContext.Provider value={{ policies, loading, error }}>
            {children}
        </PolicyContext.Provider>
    );
};

export const usePolicies = () => useContext(PolicyContext);